function weight_calc() { 
  fluid = parseFloat(document.getElementById("input_num").value);
  weightunits = document.getElementById('weight_units').value;

  if (weightunits=="metric") {
    weight = fluid;
    units = "g";
  } else if (weightunits=="imperial") {
    weight = fluid*1.04;
    units = " oz";
  } 
  
  weight = Math.round(weight*10)/10;
  document.getElementById("display_weight").innerHTML=weight;
  document.getElementById("display_units").innerHTML=units;
}

$("#weight_form").submit(function() {
    $("#weight_button").click();
    return false;
});